import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const AppWrapper = process.env.REACT_APP_ENV !== "dev"
  ? <App />
  : <React.StrictMode><App /></React.StrictMode>;

ReactDOM.createRoot(document.getElementById('root')).render(AppWrapper);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();